module.exports = __webpack_public_path__ + "ClientApp/content/In-home-euthanasia-lap-of-love.jpg";